import { calculateBookingCharges, calculateInvoiceBalance, toNonNegativeCurrency, toFiniteNumber } from "./bookingCalculations";
import { guestCount } from "./bookingPricing";

export const itemQuantity = (item) => Math.max(1, Math.floor(toFiniteNumber(item.quantity, 1)));
export const itemTotal = (item) => toNonNegativeCurrency(item.price) * itemQuantity(item);
export const hasAgreedEventTotal = (value) =>
  value !== null && value !== undefined && String(value).trim() !== "" &&
  Number.isFinite(Number(value)) && Number(value) >= 0;

export const calculateInvoiceCharges = ({
  selectedPackage, additionalKids = 0, additionalAdults = 0,
  addOnSelections = [], customItems = [], discount = 0,
  depositPaid = 0, removeTax = false, cardFeeEnabled = false,
  pricingNeedsReview = false, agreedEventTotal = "",
} = {}) => {
  const extraKids = guestCount(additionalKids) * toNonNegativeCurrency(selectedPackage?.additionalChildPrice);
  const extraAdults = guestCount(additionalAdults) * toNonNegativeCurrency(selectedPackage?.additionalAdultPrice);
  // Older bookings use only the manually reviewed all-in agreement, never
  // today's catalog or an inferred historical fee.
  const charges = pricingNeedsReview
    ? calculateBookingCharges({
        baseSubtotal: hasAgreedEventTotal(agreedEventTotal) ? agreedEventTotal : 0,
        applyTax: false,
      })
    : calculateBookingCharges({
        baseSubtotal: selectedPackage?.price,
        additionalCharges: selectedPackage
          ? extraKids + extraAdults + [...addOnSelections, ...customItems].reduce((sum, item) => sum + itemTotal(item), 0) : 0,
        discount,
        applyTax: !removeTax,
      });
  return {
    ...charges, extraKids, extraAdults,
    ...calculateInvoiceBalance(charges.finalEventTotal, depositPaid, cardFeeEnabled),
  };
};
